import type { FC } from "react";
import { useCallback, useMemo } from "react";

import { SWReactIcons } from "@similarweb/icons";
import { Checkbox, PlainTooltip } from "@similarweb/ui-components";

import { i18nFilter } from "app/filters/i18nFilter";

import {
    WidgetListItemContainer,
    WidgetListItemTextContainer,
    WidgetListItemTitle,
    WidgetListItemSubtitle,
    ItemErrorIconContainer,
} from "./DashboardPptExportListStyles";
import type { IDashboardPptExportListItemProps } from "./DashboardPptExportListTypes";

export const DashboardPptExportListItem: FC<IDashboardPptExportListItemProps> = (props) => {
    const { item, onToggle } = props;

    const services = useMemo(() => {
        return {
            translate: i18nFilter(),
        };
    }, []);

    const handleCheckboxClick = useCallback(() => {
        onToggle(item);
    }, [item, onToggle]);

    const renderCheckbox = () => {
        if (item.isDisabled) {
            return (
                <PlainTooltip
                    tooltipContent={services.translate("dashboard.export.modal.item.disabled")}
                    placement="left"
                    appendTo=".ppt-export-modal"
                >
                    <ItemErrorIconContainer>
                        <SWReactIcons
                            iconName="alert-circle"
                            size="sm"
                        />
                    </ItemErrorIconContainer>
                </PlainTooltip>
            );
        }

        return (
            <Checkbox
                label={""}
                onClick={handleCheckboxClick}
                selected={item.isSelected}
                isDisabled={false}
            />
        );
    };

    return (
        <WidgetListItemContainer>
            {renderCheckbox()}
            <WidgetListItemTextContainer>
                <WidgetListItemTitle isDisabled={item.isDisabled}>{item.viewData.title}</WidgetListItemTitle>
                <WidgetListItemSubtitle isDisabled={item.isDisabled}>{item.viewData.subtitle}</WidgetListItemSubtitle>
            </WidgetListItemTextContainer>
        </WidgetListItemContainer>
    );
};
